<template>
    <div class="terms-page">
        <page-header :title="title" :items="items" />

        <div v-if="termsOfUse.id" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <edit-form
                            v-model="termsOfUse"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-3">
                            <button
                                class="
                                    btn btn-success btn-static
                                    waves-effect waves-light
                                    m-1
                                "
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :sections="sections"
                            :item="termsOfUse"
                            :options="options"
                            @meta-change="onMetaChange"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';
import ItemInformation from '@/components/elements/ItemInformation';

import EditForm from '@/components/terms-of-use/EditForm';

export default {
    page: {
        title: 'Manage terms of use content'
    },

    validations: {
        termsOfUse: {
            header: {
                required
            },
            content: {
                required
            }
        }
    },

    components: {
        EditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            id,
            title: 'Edit terms of use',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Terms of use',
                    to: '/terms-of-use'
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            termsOfUse: {
                header: '',
                content: ''
            },
            serverErrors: [],
            options: {
                deleteButton: false
            }
        };
    },

    computed: {
        sections() {
            return {
                status: true,
                meta: true
            };
        }
    },

    async created() {
        try {
            this.termsOfUse = await this.getTermsOfUse(this.id);
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }

        return;
    },

    methods: {
        ...mapActions({
            getTermsOfUse: 'termsOfUse/show',
            updateTermsOfUse: 'termsOfUse/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const { updatedAt } = await this.updateTermsOfUse({
                    id: this.id,
                    data: this.termsOfUse
                });

                this.termsOfUse.updatedAt = updatedAt;

                this.$toaster('Terms of use updated!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data?.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        onMetaChange(meta) {
            this.termsOfUse.meta = { ...meta };
        }
    }
};
</script>
